import Vue from 'vue';
import Router from 'vue-router';
import index from '../views/index.vue';
import { perfix } from '../../utils/common'

Vue.use(Router);
const routes = [
  {
    path: '/',
    redirect:'/adminLogin',
  },
  {
    path: '/backIndex',
    name: 'backIndex',
    component: () => import('../views/'+perfix()+'index.vue'),
    children: [
      {
        //apply  特殊申报
        path: '/backIndex/apply',
        name: 'apply',
        component: () => import('../views/exhibiService/specalApply/apply.vue'),
      },
      {
        //declare  家具绿植
        path: '/backIndex/greenPlant',
        name: 'greenPlant',
        component: () => import('../views/exhibiService/greenPlant/plant.vue'),
      },
      {
        //标摊门楣
        path: '/backIndex/lintel',
        name: 'lintel',
        component: () => import('../views/exhibiService/lintel/lintel.vue'),
      },
      {
        //会刊信息
        path: '/backIndex/catalogue',
        name: 'catalogue',
        component: () => import('../views/exhibiService/catalogue/catalogue.vue'),
      },
      {
        //参展商证
        path: '/backIndex/card',
        name: 'card',
        component: () => import('../views/exhibiService/exhibitorsCard/card.vue'),
      },

      {
        //易展厅的首页
        path: '/backIndex/homeIndex',
        name: 'homeIndex',
        component: () => import('../views/'+perfix()+'Yihall/homeIndex.vue'),
      },
      {
        //展商信息
        path: '/backIndex/exhiIndex',
        name: 'exhiIndex',
        component: () => import('../views/'+perfix()+'Yihall/exhiInformat/exhiIndex.vue'),
      },
      {
        //产品中心首页
        path: '/backIndex/productIndex',
        name: 'productIndex',
        component: () => import('../views/Yihall/product/productIndex.vue'),
      },
      {
        path: '/backIndex/productView',
        name: 'productView',
        component: () => import('../views/Yihall/product/productView.vue'),
      },
      {
        //新增产品
        path: '/backIndex/addproduct',
        name: 'addproduct',
        component: () => import('../views/Yihall/product/addProduct.vue'),
      },
      {
        //编辑产品页面
        path: '/backIndex/editproduct',
        name: 'editproduct',
        component: () => import('../views/Yihall/product/addProduct.vue'),
      },
      {
        //活动列表页面
        path: '/backIndex/active_list',
        name: 'active_list',
        component: () => import('../views/Yihall/exhi_active/active_list.vue'),
      },
      {
        //新增活动页面
        path: '/backIndex/add_active',
        name: 'add_active',
        component: () => import('../views/Yihall/exhi_active/add_active.vue'),
      },

      //新增活动
      {
        path: '/backIndex/addExhiLive',
        name: 'addExhiLive',
        component: () => import('../views/Yihall/exhi_live/addexhiLive.vue'),
      },
      // {
      //     path: '/backIndex/editExhiLive',
      //     name: 'editExhiLive',
      //     component: () => import('../views/Yihall/exhi_live/editexhiLive.vue')
      // },
      {
        //展商直播页面
        path: '/backIndex/exhiLive',
        name: 'exhiLive',
        component: () => import('../views/Yihall/exhi_live/exhiLive.vue'),
      },
      {
        //展商新闻
        path: '/backIndex/exhi_news',
        name: 'exhi_news',
        component: () => import('../views/Yihall/exhi_news/exhi_news.vue'),
      },
      {
        //新增新闻
        path: '/backIndex/add_news',
        name: 'exhiNews',
        component: () => import('../views/Yihall/exhi_news/add_news.vue'),
      },
      {
        //宣传资料下载页面
        path: '/backIndex/dataIndex',
        name: 'dataIndex',
        component: () => import('../views/Yihall/dataDownd/dataIndex.vue'),
      },
      {
        //资料上传页面
        path: '/backIndex/uploadData',
        name: 'uploadData',
        component: () => import('../views/Yihall/dataDownd/uploadData.vue'),
      },
      {
        //我的信息
        path: '/backIndex/mineMessage',
        name: 'mineMessage',

        component: () => import('../views/'+perfix()+'Yihall/myMessage/minMessage.vue'),
      },
      {
        //我的信息 详情
        path: '/backIndex/messageDetail',
        name: 'messageDetail',
        component: () => import('../views/'+perfix()+'Yihall/myMessage/messageDetail.vue'),
      },

      {
        //下载中心
        path: '/backIndex/Download',
        name: 'Download',
        component: () => import('../views/'+perfix()+'Others/Download'),
      },
      {
        //原密码
        name: 'verifyPassword',
        path: '/backIndex/verifyPassword',
        component: () => import('../views/'+perfix()+'Others/Password/verifyPassword'),
      },
      /*       {
        name: 'editPassword',
        path: '/backIndex/editPassword',
        component: () => import('../views/Others/Password/editPassword'),
      }, */
      {
        //联系我们
        name: 'Connection',
        path: '/backIndex/Connection',
        component: () => import('../views/'+perfix()+'Others/Connection'),
      },
      {
        //微信邀请
        name: 'wxInvite',
        path: '/backIndex/wxInvite',
        component: () => import('../views/'+perfix()+'inviteAudience/wxInvite.vue')
      },
      {
        //pdf邀请
        name: 'pdfInvite',
        path: '/backIndex/pdfInvite',
        component: () => import('../views/inviteAudience/pdfInvite'),
      },
      {
        //团体邀请
        name: 'groupInvite',
        path: '/backIndex/groupInvite',
        component: () => import('../views/inviteAudience/groupInvite'),
      },
      {
        //邮件邀请
        name: 'emailInvite',
        path: '/backIndex/emailInvite',
        component: () => import('../views/inviteAudience/emailInvite'),
      },
    ],
  },
  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: () => import('../views/'+perfix()+'login.vue'),
  },
  // 产品详情页面
  {
    path: '/viewproduct',
    name: 'viewproduct',
    component: () => import('../views/Yihall/product/viewDetail.vue'),
  },
  // 新闻预览页面
  {
    path: '/viewnews',
    name: 'viewnews',
    component: () => import('../views/Yihall/exhi_news/newdetails.vue'),
  },
  //微信预登记
  {
    path: '/wxRegister',
    name: 'wxRegister',
    component: () => import('../views/wxRegister'),
  },
  //微信下载跳转页面
  {
    path: '/wxdownImg',
    name: 'wxdownImg',
    component: () => import('../views/wxRegister/pictureDown.vue'),
  },
  {
    path: '/wxQuestion',
    name: 'wxQuestion',
    component: () => import('../views/wxRegister/wxQuestionnaire'),
  },
  {
    path: '/wxSuccessed',
    name: 'wxSuccessed',
    component: () => import('../views/wxRegister/successed'),
  },
  

];
export default new Router({
  routes,
});
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {

  return VueRouterPush.call(this, to).catch((err) => err);
};
